<div class="scope-list" data-id="storeAuthorityScopeList">
  <a
    *ngFor="let scope of scopes(); index as i"
    class="scope-item"
    [class.selected]="scope.code === selectedCode()"
    [attr.data-id]="'storeAuthorityScopeItem' + i"
    (click)="select(scope)"
  >
    <span class="scope-icon"><em class="icon-user-store"></em></span>
    <span class="scope-name"
      ><span class="scope-code">{{ scope.code }}</span
      ><span class="scope-name-text">{{ scope.name }}</span></span
    >
    <span class="scope-store-count"
      ><span class="scope-store-count-text">{{ scope.totalStore }} stores</span
      ><em class="icon-down-arrow scope-store-count-icon"></em
    ></span>
  </a>
</div>
